import { render, staticRenderFns } from "./CallToActionPage.vue?vue&type=template&id=3376ca22&"
import script from "./CallToActionPage.vue?vue&type=script&lang=js&"
export * from "./CallToActionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports